import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserStore } from '../stores/useUser.store';
import { Button } from '@/components/shadcn-ui/button';
import { Input } from '@/components/shadcn-ui/input';
import { Label } from '@/components/shadcn-ui/label';
import { generateAuthUrl } from '@/network/project.service';
import { appAxios } from '@/network/base/appAxios';
import { toast } from 'sonner';

const AuthPage = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useUserStore();
  const isLimitExceeded = new URLSearchParams(location.search).get('limit_exceeded') === 'true';

  const handleChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleClick = async type => {
    // const { data } = await generateAuthUrl({
    //   type: type,
    //   grantType: 'email-password',
    //   clientId,
    //   clientSecret,
    //   redirectUrl,
    // });  
    const currentParams = new URLSearchParams(location.search);
    const priceId = currentParams.get('price_id');
    const from_zermit = currentParams.get('from_zermit');
    const response = await appAxios.post('/Auth/v1.0/authurl', {
      type: type,
      grantType: 'email-password',
      priceId: priceId,
      from_zermit: from_zermit,
    });
    if (response.data.data.success && response.data.data.data?.authUrl) {
      let redirectUrl = "";
      if (response.data.data.from_zermit == "true" && response.data.data.priceId) {
        redirectUrl = `${response.data.data.data?.authUrl}&price_id=${response.data.data.priceId}&from_zermit=true`;
      } else {
        redirectUrl = `${response.data.data.data?.authUrl}`;
      }
      window.location.href = redirectUrl;
    } else {
      toast.error('Auth Url not received , please try again');
    }
  };

  return (
    <div className="dark min-h-screen bg-muted flex items-center justify-center px-4 py-12 w-full">
      <main className="w-full max-w-md">
        <section className="bg-card rounded-2xl shadow-lg p-8 md:p-10 border border-border transition-all">
          {/* Header */}
          <div className="text-center mb-10">
            <h1 className="text-4xl font-bold text-primary mb-3 tracking-tight">Sign up or log in</h1>
            <p className="text-muted-foreground text-sm">
              Create your account so you can track progress and receive your approved permit here the moment it's issued
            </p>
          </div>

          {/* Rate limit banner */}
          {isLimitExceeded && (
            <div className="mb-6 rounded-lg bg-primary/10 border border-primary/30 px-4 py-3 text-center">
              <p className="text-sm font-medium text-primary italic leading-relaxed">
                You have reached your limit. <br /> Please sign up / sign in to continue.
              </p>
            </div>
          )}

          {/* Buttons */}
          <div className="flex flex-col gap-4">
            <Button
              className="py-3 text-base font-medium shadow hover:shadow-md transition"
              onClick={() => handleClick('login')}
            >
              Sign In
            </Button>

            <Button
              variant="outline"
              className="py-3 text-base font-medium shadow-sm hover:shadow transition text-white"
              onClick={() => handleClick('signup')}
            >
              Create Account
            </Button>
          </div>

          {/* Divider */}
          <div className="mt-8 flex items-center gap-4">
            <div className="flex-1 h-px bg-border"></div>
            <span className="text-xs text-muted-foreground">Info</span>
            <div className="flex-1 h-px bg-border"></div>
          </div>

          {/* Footer */}
          <p className="mt-4 text-center text-sm text-muted-foreground">Use signin or create account to continue</p>
        </section>
      </main>
    </div>
  );
};

export default AuthPage;
